var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.532318 19.1675L3.25095 18.2191L1.19617 17.2708L0.532318 19.1675Z",
    fill: "#F7B600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40367 11.3909L4.57862 7.53424L3.94638 9.30451L8.40367 11.3909Z",
    fill: "#FFDD7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94642 9.30457L3.25095 11.2961L11.723 15.2476L12.1339 15.1212L8.40371 11.391L3.94642 9.30457Z",
    fill: "#F7B600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58706 13.2876L8.90946 16.2276L11.7229 15.2476L3.25092 11.2961L2.58706 13.2876Z",
    fill: "#FFDD7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89164 15.2792L6.06442 17.2391L8.9095 16.2275L2.5871 13.2876L1.89164 15.2792Z",
    fill: "#F7B600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89162 15.2792L1.19615 17.2707L3.25093 18.2191L6.0644 17.2391L1.89162 15.2792Z",
    fill: "#FFDD7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98431 9.74706C12.1023 11.8335 13.2087 14.1727 12.4501 14.9314C11.6597 15.6901 9.32046 14.6153 7.17084 12.4973C5.05284 10.4109 3.94642 8.07162 4.70511 7.31293C5.49541 6.55425 7.8347 7.66067 9.98431 9.74706Z",
    fill: "#493816"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32887 4.46793C6.82307 3.74086 7.36048 3.42474 8.05594 3.55118C7.39209 2.76088 7.80305 2.19187 8.84624 2.41315C9.16236 2.47638 8.71979 3.01378 8.43529 3.01378C9.28881 3.64602 8.81463 4.34149 7.89788 4.18343C8.71979 5.28985 7.32887 5.00534 6.69663 5.06856C6.53857 5.89047 7.48693 6.83883 7.17081 6.83883C6.47534 6.83883 5.33731 4.21504 7.32887 4.46793Z",
    fill: "#42ADE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9674 5.98526C13.4933 6.20654 12.1656 4.12015 13.8094 4.08854C12.861 3.23501 12.9875 2.82406 14.2519 2.79244C12.7978 1.33829 15.1055 0.832499 15.3268 1.59119C15.39 1.81247 14.6313 1.40152 14.3784 1.81247C14.0939 2.28665 16.1487 3.51952 14.0307 3.42468C14.821 4.21498 14.8526 4.59433 13.6197 4.72078C13.7778 4.97367 14.2836 5.85881 13.9674 5.98526Z",
    fill: "#FF8736"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5048 10.9167L14.979 10.5058C14.979 10.5058 15.4216 11.1696 15.7377 11.4225C15.9906 10.2845 15.9273 9.62066 17.2234 10.3793C16.4964 8.4194 17.6976 9.14648 18.8673 9.68388C18.804 9.17809 18.8673 9.24131 19.3731 9.08325C19.8156 10.7587 18.6144 10.2529 17.666 9.71549C18.235 11.2329 17.6344 11.138 16.4331 10.6322C16.4015 11.2645 16.2119 11.9916 15.8325 12.0548C15.3899 12.1812 14.5048 10.9167 14.5048 10.9167Z",
    fill: "#ED4C5C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9643 6.23817C10.3953 6.99686 9.47854 7.40782 8.81469 8.07167C8.11923 8.76713 7.70827 10.6639 7.70827 10.6639C7.70827 10.6639 7.96117 8.6723 8.62502 7.91361C9.22565 7.21814 10.1108 6.71235 10.585 5.92205C11.4069 4.4679 10.6482 2.57118 9.57338 1.46476C9.79466 1.27509 10.1108 1.02219 10.2688 0.83252C11.312 2.12861 12.1972 4.62596 10.9643 6.23817Z",
    fill: "#C28FEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9443 7.85038C11.1224 8.451 10.5217 9.33614 9.95271 10.1581C9.44692 10.8851 7.83471 11.8019 7.83471 11.8019C7.83471 11.8019 9.35209 10.7587 9.82627 9.99999C10.3953 9.05163 10.9643 8.07166 11.8494 7.3762C13.6197 6.01688 16.1803 6.14333 18.1718 6.8704C18.0454 7.15491 17.8241 7.75554 17.8241 7.75554C17.8241 7.75554 13.6197 6.61751 11.9443 7.85038Z",
    fill: "#FF8736"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4532 7.69236C14.9158 8.38782 14.6629 9.24135 14.2519 10.0316C13.8726 10.7587 13.3668 11.4542 12.6397 11.8335C11.8178 12.2445 10.0159 12.118 10.0159 12.118C10.0159 12.118 11.8178 12.0864 12.5765 11.5806C13.3352 11.0748 13.7462 10.1897 14.0307 9.3678C14.5997 7.7872 15.2951 6.08015 16.939 5.38468C17.0338 5.66919 17.2551 6.26982 17.2551 6.26982C17.2551 6.26982 16.3383 6.52272 15.4532 7.69236ZM0.914837 4.41261L1.80882 3.51831L2.70313 4.4123L1.80914 5.30692L0.914837 4.41261Z",
    fill: "#42ADE2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16758 7.21723L3.06125 6.32324L3.95524 7.21723L3.06125 8.11122L2.16758 7.21723Z",
    fill: "#FF8736"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4389 2.98902L5.33289 2.09503L6.22688 2.98902L5.33289 3.88301L4.4389 2.98902Z",
    fill: "#ED4C5C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1903 13.6973L15.0843 12.803L15.9783 13.6973L15.0843 14.5913L14.1903 13.6973Z",
    fill: "#C28FEF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1981 16.7618L13.0921 15.8678L13.9864 16.7621L13.0921 17.6561L12.1981 16.7618Z",
    fill: "#ED4C5C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1104 17.4626L17.0044 16.5683L17.8984 17.4626L17.0044 18.3566L16.1104 17.4626Z",
    fill: "#FF8736"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9952 13.3923L17.8892 12.4983L18.7832 13.3923L17.8892 14.2866L16.9952 13.3923ZM15.5025 3.93776L16.3965 3.04346L17.2908 3.93776L16.3968 4.83175L15.5025 3.93776Z",
    fill: "#42ADE2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92023 9.30201L6.81453 8.40802L7.70852 9.30201L6.81453 10.1963L5.92023 9.30201Z",
    fill: "#ED4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.2f3160c280a17eef044da12cf9242c66.svg";
export { ForwardRef as ReactComponent };